export {default as BarTab} from 'components/BarTab/BarTab';
export {default as Tab} from 'components/BarTab/Tab';
export {default as TabContent} from 'components/BarTab/TabContent';



// WEBPACK FOOTER //
// ./src/components/BarTab/index.jsx